{
	"title": "Karbonfangede attributter",
	"buttonTitle": "Karbonfangst og lagring",
	"table": {
		"materialDescription": "Materiale",
		"quantity": "Mengde",
		"productGwpTotal": "Produkt GWP totalt",
		"bundledCarbonReductions": "Samlede karbonreduksjoner",
		"remainingGwp": "Gjenværende GWP",
		"epdForPhysicalMaterial": "EPD for fysisk materiale",
		"carbonPlantName": "Brevik, Norge"
	},
	"declarationDetailsBanner": {
		"rightfulHolderText": "er den rettmessige innehaveren av de rapporterte karbonreduksjonene."
	},
	"modal": {
		"title": "Karbonfangst og lagring",
		"description": "Carbon Capture and Storage (CCS) er en teknologi som kan fange opp karbondioksid (CO2)-utslippene som produseres fra kalsineringsprosessen og bruken av brensel i ovnsdriften, og hindrer karbondioksidet i å komme inn i atmosfæren og lagre det permanent under jorden. CO2 som fanges opp fra Heidelberg Materials' anlegg i Brevik, Norge, komprimeres og transporteres gjennom til et lagringssted under Nordsjøen. Anlegget ved vårt Brevik-anlegg skal fange 400.000 tonn CO2 årlig.",
		"showLink": "Lær mer om karbonfangstprosessen",
		"buttonClose": "Lukk"
	},
	"footnote": "1) Karbonreduksjoner kompenserer for trinn A1-A3 i livssyklusbeholdningen av sement."
}
